import { render, staticRenderFns } from "./Import-Detail-Msisdn.vue?vue&type=template&id=0461f2ae"
import script from "./Import-Detail-Msisdn.vue?vue&type=script&lang=js"
export * from "./Import-Detail-Msisdn.vue?vue&type=script&lang=js"
import style0 from "./Import-Detail-Msisdn.vue?vue&type=style&index=0&id=0461f2ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports